<template>
    <div>
        <div class="d-flex" id="container">
            <span class="p-2 mt-1">
                <i class="fa fa-plus cursor-pointer" @click="showDetails" v-if="!details"></i>
                <i class="fa fa-minus cursor-pointer" @click="showDetails" v-if="details"></i>
            </span>
            <div class="card">
                <div class="card-header m-0">
                    <div class="d-flex justify-content-between" id="invite-details">
                        <span class="item" style="flex-grow: 1.4;">
                            <input
                                class="mr-2"
                                v-model="selectedInvite"
                                type="checkbox"
                                :id="'invites-' + invites.id"
                                @change="select(invites.id)"
                                :value="invites.id"/>
                            <span class="mr-2">
                                {{ name }}
                            </span>
                        </span>
                        <span class="item">
                            <i class="fa fa-phone mr-1"></i>
                            <span v-if="phoneNumber">
                                {{ phoneNumber }}
                            </span>
                            <span v-if="!phoneNumber">
                                <em class="text-muted mr-2">No phone number</em>
                            </span>
                        </span>
                        <span class="item" style="flex-grow: 2;">
                            <i class="fa fa-envelope mr-1"></i>
                            <span v-if="email">{{ email }}</span>
                            <span v-if="!email">
                                <em class="text-muted">No email</em>
                            </span>
                        </span>
                        <span class="item">
                            <i class="far fa-calendar-alt mr-1"></i>
                            <span v-if="sentAt">
                                {{ sentAt | date }}
                            </span>
                            <span v-if="!sentAt">
                                <em class="text-muted">Not sent</em>
                            </span>
                        </span>
                        <span id="status">
                            <div class="small" :style="statusColor">
                                {{ status }}
                            </div>
                        </span>
                    </div>
                </div>
                <transition name="fade-in-down">
                    <div class="card-body p-0" v-if="details">
                        <grid-content>
                            <grid-content-row>
                                <location-info :invite="invites"></location-info>
                            </grid-content-row>
                            <grid-content-row>
                                <tags v-model="invites.tags"
                                    :options="tags"
                                    @input="updateInvite(invites)">
                                </tags>
                            </grid-content-row>
                        </grid-content>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import LocationInfo from './InviteLocationInfo';

    export default {
        props: ['invites', 'tags', 'selectedInvites'],

        data: () => ({
            details: false
        }),

        components: {
            LocationInfo
        },

        computed: {
            selectedInvite: {
                get() {
                    return this.selectedInvites;
                },
                set() {}
            },

            name() {
                return this.invites.contact.name;
            },

            email() {
                return this.invites.contact.email;
            },

            phoneNumber() {
                return this.invites.contact.phone_number;
            },

            sentAt() {
                return this.invites.sent_at;
            },

            status() {
                return this.invites.status;
            },

            statusDefaultStyle() {
                return `width: 77px; color: #fff; text-align: center; border-radius: 7px;`;
            },

            statusColor() {
                if (this.isShared) {
                    return `background: #249D68; ${this.statusDefaultStyle}`;
                }
                if (this.isExpired) {
                    return `background: #609daf; ${this.statusDefaultStyle}`;
                }
                if (this.isScheduled) {
                    return `background: #FFB90D; ${this.statusDefaultStyle}`;
                }
                if (this.isSent) {
                    return `background: #616A72; ${this.statusDefaultStyle}`;
                }
                if (this.isFailed) {
                    return `background: #D72E3D; ${this.statusDefaultStyle}`;
                }
                if (this.isOpened) {
                    return `background: #0070FF; ${this.statusDefaultStyle}`;
                }
                if (this.isQueued) {
                    return `background: #563d7c; ${this.statusDefaultStyle}`;
                }
            }
        },

        methods: {
            showDetails() {
                this.details = !this.details;
            },
            select(id) {
                this.$emit('selected', id);
            }
        }
    };
</script>


<style lang="scss" scoped>
    .d-flex {
        flex-wrap: wrap;
    }

    .item {
        flex: 1 1;
    }

    .card {
        border-radius: 0;
        flex-grow: 1;
    }

    #container {
        margin-bottom: -20px;
    }

    @media screen and (max-width: 991px) {
        #container {
            flex-direction: column;
            align-items: center;
        }

        #status {
            margin: auto;
        }

        .card {
            width: 100%;
        }

        #invite-details {
            flex-direction: column;
            text-align: center;
        }

        .item:not(:last-child) {
            margin-bottom: 10px;
        }
    }
</style>
